import * as r from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/HardDrives.es.js";
const e = r.forwardRef((o, a) => /* @__PURE__ */ r.createElement(s, { ref: a, ...o, weights: t }));
e.displayName = "HardDrivesIcon";
const c = e;
export {
  c as HardDrives,
  e as HardDrivesIcon
};
